export const BACKSPACE_KEY = 'Backspace'
export const ENTER_KEY = 'Enter'
export const NUMBERS = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
]
